// src/components/common/SpinnerLoading.js
import React from "react";
import styled from "styled-components";
import { PulseLoader } from "react-spinners";

// Styled full-screen overlay (replaces Reactstrap Modal)
const SpinnerOverlay = styled.div`
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.75);
    z-index: 9999;
`;

// Optional custom override for fine-tuning loader
const override = {
    display: "block",
    margin: "0 auto",
};

const SpinnerLoading = () => {
    return (
        <SpinnerOverlay>
            <PulseLoader
                color="#19ade4"
                loading={true}
                cssOverride={override}
                size={15}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </SpinnerOverlay>
    );
};

export default SpinnerLoading;
